import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';
import mainService from '../services/mainService';
import config from '../services/config.json';
import './Categories.css';

const toUrl = (p) => {
	if (!p || typeof p !== 'string') return null;
	return p.startsWith('http') ? p : (config.apiUrl + p);
};

const pickCategoryImage = (category) => {
	if (!category || !Array.isArray(category.Products)) return null;
	for (const prod of category.Products) {
		const candidate = toUrl(prod?.Image1 || prod?.Image2 || prod?.Image3 || prod?.Image4 || prod?.Image5);
		if (candidate) return candidate;
	}
	return 'https://via.placeholder.com/600x400/1a1a1a/ffffff?text=Category';
};

const Categories = () => {
	const [searchParams] = useSearchParams();
	const categoryId = searchParams.get('id');
	const categoryType = searchParams.get('type');
	const categoryName = decodeURIComponent(searchParams.get('name') || '');
	
	const [featuredCategories, setFeaturedCategories] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	useEffect(() => {
		const fetchFeatured = async () => {
			try {
				setLoading(true);
				setError(null);
				const data = await mainService.categoriesWithProducts();
				setFeaturedCategories(Array.isArray(data) ? data : []);
			} catch (err) {
				console.error('Failed to load featured categories:', err);
				setError('Failed to load featured categories. Please try again later.');
			} finally {
				setLoading(false);
			}
		};
		fetchFeatured();
	}, []);

	return (
		<div className="categories-page">
			<div className="container">
				<div className="page-header">
					<h1 className="page-title">
						{categoryType === 'categories' ? 'Shop by Categories' : 'Shop by Categories'}
					</h1>
					<p className="page-subtitle">Browse our collections and find what you love</p>
				</div>

				{loading && (
					<div className="loading-container">
						<div className="loading-spinner"></div>
						<p>Loading categories...</p>
					</div>
				)}

				{error && !loading && (
					<div className="error-container">
						<p className="error-message">{error}</p>
					</div>
				)}

				{!loading && !error && (
					<>
						{/* Featured Categories powered by CategoriesWithProductsForHome */}
						<section className="featured-categories">
							<h2 className="section-title"></h2>
							<div className="featured-grid">
								{featuredCategories.map((cat, index) => {
									const image = pickCategoryImage(cat);
									const name = cat?.Name || 'Category';
									const count = Array.isArray(cat?.Products) ? cat.Products.length : 0;
									return (
										<Link
											key={name}
											to={`/products?id=${cat?.Id || 0}&type=category&name=${encodeURIComponent(name)}`}
											className="featured-card"
										>
											<div className="featured-image">
												<img src={image} alt={name} loading={index < 4 ? 'eager' : 'lazy'} decoding="async" />
											</div>
											<div className="featured-content">
												<div className="category-name">{name}</div>
												<p className="category-description">Explore top picks from {name}</p>
												<div className="category-meta">
													<span className="product-count">{count} items</span>
													<FaArrowRight className="arrow-icon" />
												</div>
											</div>
										</Link>
									);
								})}
							</div>
						</section>
					</>
				)}
			</div>
		</div>
	);
};

export default Categories;
